import { Injectable } from "@angular/core";
import { GestionRoyaltiesFilters } from "../models/gestion-royalties-filters.component";
import { MantenimientoRoyaltiesFilters } from "../models/mantenimiento-royalties-filters.component";

@Injectable()
export class RoyaltiesContextService {
    gestionRoyaltiesFilters: GestionRoyaltiesFilters;
    mantenimientoRoyaltiesFilters: MantenimientoRoyaltiesFilters;
}